export const SIGNIN_FORM = 'signIn'

export const ACCEPT_CONDITION = 'acceptCondition'
export const PASSWORD = 'password'
export const PASSWORD_CONFIRMATION = 'passwordConfirmation'